'use strict';

angular.module('constants').constant('TrackingConstants', {
  onboardingUiElement: {
    ONBOARDING_BUTTON: 'Open Onboarding Button',
    PREVIOUS_BUTTON: 'Previous Button',
    NEXT_BUTTON: 'Next Button',
    CLOSE_BUTTON: 'Close Button',
    BEGIN_BUTTON: 'Begin Training Button',
    END_BUTTON: 'End Training Button',
    MAIL_TO_LINK: 'Billing Email Link',
    EXTERNAL_LINK: 'Link to OC.com',
  },

  onboardingSteps: {
    WELCOME: 'Welcome Step',
    INTRO: 'Intro Step',
    REQUESTS: 'Requests Step',
    APPOINTMENT_FEATURES: 'Appointment Features Step',
    COMPLETING_APPOINTMENTS: 'Completing Appointments Step',
    ACCOUNT_SETTINGS: 'Account Settings Step',
    BILLING: 'Billing Step',
    TAKEAWAYS: 'Takeaways Step',
    SUMMARY: 'Summary Step',
  },
});
